var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDyslexicIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "-23.5 56.5 32 32",
    enableBackground: "new -23.5 56.5 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-9.072,77.875c0.186,0.479,0.439,0.944,0.756,1.396c1.169,1.483,2.8,2.229,4.9,2.229 c0.741,0,1.431-0.105,2.069-0.32c1.993-0.662,2.985-2.132,2.985-4.417c-0.025-3.533-3.52-5.352-10.47-5.457v-2.55 c0-0.504,0.024-0.969,0.077-1.394c0.266-1.884,1.196-2.827,2.79-2.827c0.425,0,0.808,0.08,1.151,0.238 c0.504,0.266,0.917,0.944,1.237,2.032c0.106,0.319,0.185,0.543,0.237,0.678c0.37,0.98,1.035,1.471,1.992,1.471 c0.237,0,0.479-0.037,0.714-0.118c0.853-0.266,1.279-0.85,1.279-1.754c0-0.476-0.148-0.928-0.438-1.354 C-0.776,64.242-2.938,63.5-6.285,63.5c-0.744,0-1.448,0.066-2.111,0.198c-3.239,0.639-4.859,2.671-4.859,6.093v8.361 c0,1.278-0.305,1.94-0.916,1.993c-0.795-0.024-1.274-0.969-1.434-2.825l-1.034,0.041c0.051,0.738,0.146,1.378,0.278,1.911 c0.451,1.483,1.62,2.229,3.506,2.229C-10.759,81.473-9.497,80.262-9.072,77.875z M-6.285,79.589 c-1.246-0.559-2.098-1.737-2.546-3.547v-3.623c1.327,0.025,2.413,0.16,3.261,0.4c1.807,0.479,2.71,1.621,2.71,3.423 c0,0.134,0,0.267,0,0.397c-0.107,2.127-0.903,3.186-2.389,3.186C-5.57,79.825-5.913,79.751-6.285,79.589z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDyslexicIcon);
export default __webpack_public_path__ + "static/media/DyslexicIcon.47a95d01.svg";
export { ForwardRef as ReactComponent };